export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-internacional.455e362f.pdf";